import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function DocumentTitle() {
  const { t, i18n } = useTranslation(['layouts']);

  useEffect(() => {
    const updateTitle = () => {
      document.title = t('title');
    };

    // Update title when component mounts and when language changes
    updateTitle();
    i18n.on('languageChanged', updateTitle);

    return () => {
      i18n.off('languageChanged', updateTitle);
    };
  }, [t, i18n]);

  return null;
}
